import imageCompression from "browser-image-compression";

/** WEBP as the single storage format; PDF generation converts to JPEG on the fly. */
const WEBP_MIME = "image/webp";
const MAX_SIZE_MB = 1;
const MAX_WIDTH_OR_HEIGHT = 1920;
const QUALITY = 0.8;

const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "webp",
  "heic",
  "heif",
  "gif",
  "bmp",
  "tif",
  "tiff",
  "avif",
]);

const renameWithWebpExtension = (file: File): string => {
  const base = file.name.replace(/\.[^.]+$/, "") || "photo";
  return `${base}.webp`;
};

const hasImageExtension = (fileName: string): boolean => {
  const ext = fileName.split(".").pop()?.toLowerCase() ?? "";
  return IMAGE_EXTENSIONS.has(ext);
};

/**
 * Accept any image (including empty MIME / HEIC from mobile) and compress to WEBP —
 * same compression approach as manager incidents; PDFKit conversion happens in backend.
 */
export const normalizeImageFile = async (file: File): Promise<File> => {
  const isImageMime = file.type.startsWith("image/");
  const looksLikeImage =
    isImageMime || file.type === "" || hasImageExtension(file.name);

  if (!looksLikeImage) {
    throw new Error(`Formato no soportado: ${file.type || file.name}`);
  }

  const compressed = await imageCompression(file, {
    maxSizeMB: MAX_SIZE_MB,
    maxWidthOrHeight: MAX_WIDTH_OR_HEIGHT,
    useWebWorker: true,
    fileType: WEBP_MIME,
    initialQuality: QUALITY,
  });

  return new File([compressed], renameWithWebpExtension(file), {
    type: WEBP_MIME,
    lastModified: Date.now(),
  });
};
